import { useEffect, useState } from "react";

import { Card } from "primereact/card";
import { Dialog } from "primereact/dialog";

import { C, themeClasses as T } from "../../../utils";
import { getSiteSettings } from "../../../../api";
import { Skeleton } from "primereact/skeleton";

export const NavContact = ({
  isVisible,
  onVisibilityChange,
}: {
  isVisible: boolean;
  onVisibilityChange: (value: boolean) => void;
}) => {
  const [contact, setContact] = useState<string>("");

  useEffect(() => {
    const fetchSiteSettings = async () => {
      try {
        const data = await getSiteSettings();
        setContact(data?.site?.contacts ?? "");
      } catch (_error) {
        setContact("Failed to load contact information.");
      }
    };

    if (isVisible && !contact) {
      fetchSiteSettings();
    }
  }, [isVisible]);

  return (
    <div className="card flex justify-content-center">
      <Dialog
        header="Contact Your Security Team"
        visible={isVisible}
        draggable={false}
        style={{ width: "50vw" }}
        onHide={() => onVisibilityChange(false)}
      >
        <div className="flex flex-col gap-8">
          <p>
            Your questions and comments are crucial. We are your security team, so please contact us
            and let&#39;s have a conversation.
          </p>
          <Card className={C(T.bgElevation2, "whitespace-pre-line")}>
            <p>{contact || <ContactSkeleton />}</p>
          </Card>
        </div>
      </Dialog>
    </div>
  );
};

const ContactSkeleton = () => (
  <div className="flex flex-col gap-2">
    <Skeleton width="60%" />
    <Skeleton width="80%" />
    <Skeleton width="90%" />
    <Skeleton width="70%" />
  </div>
);
